<template>
  <div
    @click="redirectToPage('redesign.candidate.shop.cart.index')"
    class="flex cursor-pointer items-center justify-center gap-x-2"
  >
    <Icon name="shopping_cart" class="text-secondary"> </Icon>
    <span class="hidden font-semibold sm:block"> {{ __('My cart') }}</span>
    <div
      class="flex h-6 w-6 items-center justify-center rounded-full bg-secondary"
    >
      <span class="text-xs font-semibold text-white">
        {{ getTotalCartItems() }}
      </span>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import { __, redirectToPage } from '@/helpers';
  import { defineProps } from 'vue';
  import Icon from '@/components/global/Icon.vue';

  const props = defineProps({
    data: {
      type: Array,
      default: () => []
    }
  });

  const getTotalCartItems = () => {
    if (props.data) {
      return Object.values(props.data).reduce(
        (total, item) => total + item.quantity,
        0
      );
    }
    return 0;
  };
  console.log('CART DATA', props.data);
</script>
